import React, { useState } from "react";
import { Col, Modal, Row, Form } from "reactstrap";

export default function ShowEmail({
  data,
  modal_center,
  setmodal_center,
  tog_center,
}) {
  const styles = {
    item: {
      fontSize: 16,
      marginBottom: 15,
      fontFamily: "cairo",
    },
  };

  return (
    <Modal
      isOpen={modal_center}
      toggle={() => {
        tog_center();
      }}
      centered
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          style={{ display: "flex", alignItems: "center" }}
        >
          <i class="ri-mail-line" style={{ paddingRight: 5 }}></i> Email
        </h5>
        <button
          type="button"
          onClick={() => {
            setmodal_center(false);
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body" style={{ direction: "rtl" }}>
        <Row className="mb-2">
          <Col md="12" style={styles.item}>
            <strong>الاسم:</strong> {data.name}
          </Col>
          <Col md="12" style={styles.item}>
            <strong>المدينة:</strong> {data.city}
          </Col>
          <Col md="12" style={styles.item}>
            <strong>رقم الهاتف:</strong> {data.phone}
          </Col>
          <Col md="12" style={styles.item}>
            <strong>المنتج:</strong> {data.product}
          </Col>
          <Col md="12" style={styles.item}>
            <strong>الشكوى:</strong> {data.desc}
          </Col>
          {data.feedback == null || data.feedback == "" ? null : (
            <Col md="12" style={styles.item}>
              <strong>تم الحل:</strong> {data.feedback}
            </Col>
          )}
          <Col md="12" style={styles.item}>
            <strong>الصورة / الفيديو:</strong>{" "}
            <img
              width="100%"
              src={
                "https://customer-service-product.com/public" + data.filepath
              }
            />
          </Col>
        </Row>

        <hr />

        <div className="d-flex flex-wrap gap-2 justify-content-center">
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={() => {
              setmodal_center(false);
            }}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
}
